"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToFiveDecimal = void 0;
function fixPrecision(input) {
    const num = Number(input);
    if (Number.isNaN(num))
        return num;
    return parseFloat(num.toPrecision(12));
}
exports.default = fixPrecision;
function roundToFiveDecimal(input) {
    const num = Number(input);
    if (Number.isNaN(num))
        return num;
    // Use toFixed to avoid floating point issues, then convert back to number
    return Number(num.toFixed(5));
}
exports.roundToFiveDecimal = roundToFiveDecimal;
//# sourceMappingURL=fixPrecision.js.map